var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refuseInvitation defatult-bg"},[_c('div',{staticClass:"text"},[_vm._v("\n    本次活动已结束，感谢您对高毅资产的信任和支持！\n  ")]),_c('footer-message',{staticStyle:{"color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }